// extracted by mini-css-extract-plugin
export default {"detailsWrapper":"DetailsPageDetailsWrapper_detailsWrapper__g1of9"};